import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  root: {
    width: '100%',
  },
  ul: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}))
